import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Bus = function Bus(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M8.5 19v2.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C8.12 22 7.98 22 7.7 22H5.8c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C5 21.62 5 21.48 5 21.2V19m14 0v2.2c0 .28 0 .42-.0545.527a.5.5 0 0 1-.2185.2185C18.62 22 18.48 22 18.2 22h-1.9c-.28 0-.42 0-.527-.0545a.5.5 0 0 1-.2185-.2185C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12h18M3 5.5h18m-14.5 10H8m8 0h1.5M7.8 19h8.4c1.6802 0 2.5202 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 16.7202 21 15.8802 21 14.2V6.8c0-1.6802 0-2.5202-.327-3.162a3 3 0 0 0-1.311-1.311C18.7202 2 17.8802 2 16.2 2H7.8c-1.6802 0-2.5202 0-3.162.327a3 3 0 0 0-1.311 1.311C3 4.2798 3 5.1198 3 6.8v7.4c0 1.6802 0 2.5202.327 3.162a3 3 0 0 0 1.311 1.311C5.2798 19 6.1198 19 7.8 19"
    })
  }));
};
export default Bus;